var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"d-column",attrs:{"fluid":""}},[_c('empty-message',{attrs:{"message":"Completando proceso"}}),_c('b-spinner',{staticClass:"mx-auto",attrs:{"variant":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }